<template>
  <swiper-container
    navigation="true"
    pagination="true"
    slides-per-view="1"
    loop="true"
    autoplay-delay="3000"
    autoplay-disable-on-interaction="false"
    class="grid h-full w-fit"
  >
    <swiper-slide
      v-for="image in images"
      :key="image.id"
    >
      <a
        :href="image?.custom_properties?.href"
        class="flex size-full w-full max-w-full items-center justify-center"
      >
        <img
          :src="image?.original_url"
          class="h-full max-h-60 object-contain object-center sm:max-h-none"
          :alt="image.alt_text || 'Carousel Image'"
        >
      </a>
    </swiper-slide>
  </swiper-container>
</template>

<script>
export default {
  name: 'Carousel',
  props: {
    images: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      activeIndex: 0,
      imageList: Object.values(this.images),
    };
  },
  computed: {
    carouselImage() {
      return this.imageList[this.activeIndex];
    },
  },
  methods: {
    next() {
      if (this.activeIndex < this.imageList.length - 1) {
        this.activeIndex++;
      } else {
        this.activeIndex = 0;
      }
    },
    prev() {
      if (this.activeIndex > 0) {
        this.activeIndex--;
      } else {
        this.activeIndex = this.imageList.length - 1;
      }
    },
  },
};
</script>

<style>
  .swiper-button-next,
  .swiper-button-prev {
    color: white;
    background-color: rgba(0, 0, 0, 0.5);
    padding: 1rem;
    border-radius: 50%;
    top: 50%;
    transform: translateY(-50%);
  }

  .swiper-button-next {
    right: 10px;
  }

  .swiper-button-prev {
    left: 10px;
  }

  /* On hover */
  .swiper-button-next:hover,
  .swiper-button-prev:hover {
    background-color: rgba(0, 0, 0, 0.8);
  }

  swiper-slide {
    width: 100% !important;
  }
</style>

<!-- <template>
  <div class="bg-black text-white" />
  <div class="relative size-full ">
    <div class="absolute left-0 top-0 z-10 flex h-full items-center 2xl:px-3">
      <v-icon
        icon="mdi:chevron-left"
        class="z-20 cursor-pointer text-4xl"
        @click="prev"
      />
    </div>
    <div
      class="left-0 top-0 flex size-full justify-center"
    >
      <a
        :href="carouselImage?.custom_properties?.href"
        target="_blank"
      >
        <img
          key="carouselImage"
          :src="carouselImage.original_url"
          class="h-full max-h-60 object-contain object-center sm:max-h-none"
        >
      </a>
    </div>
    <div class="absolute right-0 top-0 z-10 flex h-full  items-center 2xl:px-3">
      <v-icon
        icon="mdi:chevron-right"
        class="z-20 cursor-pointer text-4xl"
        @click="next"
      />
    </div>
  </div>
</template>
-->
